import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { FactoryService } from 'src/app/Services/historique/factory.service';
import { SharedService } from 'src/app/Services/sheared/sharedService.service';


@Component({
  selector: 'app-ResponseCotation',
  templateUrl: './ResponseCotation.page.html',
  styleUrls: ['./ResponseCotation.page.scss'],
})
export class ResponseCotationPage implements OnInit {
  icon
  TypeObjet: string = ""
  objet:any
  libelle_Activite:string=""
  nbPers:number=0
  constructor(private modalCtrl: ModalController,private _fact:FactoryService,
    private _sheard:SharedService,
     private nvparms: NavParams) {
    this.TypeObjet = this.nvparms.get('value').TypeObjet;
    //console.log(this._fact.getData(150));
    

    //this._fact.getData(150)
  }
  ngOnInit(): void {
   let timer=  setTimeout(() => {
      if (this.TypeObjet==='AUTOMOBILE') {
        this.objet=this._fact.getData(150)
      }
      if (this.TypeObjet==='INDIVIDUELLE') {
        this.objet="1"
        this.icon="../../../assets/img/indiv.png"
        this._fact.getnbComponent().forEach(e =>{
          if(!isNaN(this._fact.getData(e).primeCapitaux)){
            let Id_Indiv=this._fact.getData(e)
            this.libelle_Activite += Id_Indiv.libelle_Activite.toString()//+";"
            this.nbPers += Id_Indiv.nbPers
            
          }  
        })
      }
      if(this.TypeObjet==='VOYAGE'){
        this.objet= this._fact.getData(150)
        this.objet.dateDebut=this._sheard.ConvertDMYorYMD(this.objet.dateDebut.split('T')[0])
        this.objet.dateFin=this._sheard.ConvertDMYorYMD(this.objet.dateFin.split('T')[0])
      }
      if(this.TypeObjet==='MULTIRISQUE'){
        this.objet= this._fact.getData(150)
      }
      if(this.TypeObjet==='SANTE'){
        this.objet = this._fact.getData(150)
        this.objet.eff=0
        this.objet.Ad=0
        this.objet.Ef=0
        
       let h= this.objet.adulte as any[]
        h.map(e  =>{
          this.objet.Ad += e.value*1
        } )
        let h0= this.objet.enfant as any[]
        h0.map(e  =>{
          this.objet.Ef += e.value*1
        } )
        this.objet.eff=this.objet.Ef+this.objet.Ad
       // this.dta.eff=this.dta.adulte.length + this.dta.adulte.enfant
        this.objet.formule=(this.objet.forml0 + this.objet.forml1).trim()
      }
      clearTimeout(timer)
    },100);

  }

  async onCloseModal() {

    this.modalCtrl.dismiss()


  }



}
